import { Link } from 'react-router-dom';

interface MovieCardProps {
  id: number;
  title: string;
  category: string;
  year: number;
  rating: number;
  type: 'movie' | 'tv';
  posterUrl: string;
  isNew?: boolean;
  categoryName?: string;
}

export default function MovieCard({ id, title, year, rating, type, posterUrl, isNew, categoryName }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${id}`}
      className="group block cursor-pointer"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    >
      <div className="relative overflow-hidden rounded-lg aspect-[2/3] bg-background-200">
        <img
          src={posterUrl}
          alt={title}
          title={`${title} - 农民影视高清在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>

        {isNew && (
          <span className="absolute top-2.5 left-2.5 px-2 py-0.5 bg-accent-500 text-white text-xs font-semibold rounded-md whitespace-nowrap">
            NEW
          </span>
        )}

        <span className="absolute top-2.5 right-2.5 px-2 py-0.5 bg-background-950/70 backdrop-blur-sm text-accent-400 text-xs font-semibold rounded-md whitespace-nowrap">
          {rating}
        </span>

        <div className="absolute bottom-0 left-0 right-0 p-3">
          <h3 className="text-white text-sm font-semibold leading-tight line-clamp-1 whitespace-nowrap">{title}</h3>
          <div className="flex items-center gap-2 mt-1">
            <span className="text-white/60 text-xs">
              {year}
            </span>
            {categoryName && (
              <span className="text-white/50 text-xs">· {categoryName}</span>
            )}
            <span className="text-white/50 text-xs">
              · {type === 'movie' ? '电影' : '剧集'}
            </span>
          </div>
        </div>

        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-white">
            <i className="ri-play-fill text-xl ml-0.5"></i>
          </div>
        </div>
      </div>
    </Link>
  );
}